/* Small chrome pieces shared by every admin page. */

/* Layouten bor i styles.css (.page-head) så att mobilen kan bryta raden. */
export function PageHead({ title, sub, right, sticky }) {
  return (
    /* sticky: knapparna (t.ex. Ny vara) följer med när listan scrollas */
    <div className={'page-head' + (sticky ? ' page-head-sticky' : '')}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="page-head-title">{title}</div>
        {sub && <div className="page-head-sub">{sub}</div>}
      </div>
      {right && <div className="page-head-right">{right}</div>}
    </div>
  );
}

/** Segmenterad väljare — `options` är [värde, etikett]-par. */
export function Segmented({ value, onChange, options }) {
  return (
    <div className="segmented">
      {options.map(([id, label]) => (
        <button key={String(id)} onClick={() => onChange(id)} style={{
          padding: '9px 18px', border: 'none', borderRadius: 9, cursor: 'pointer', fontWeight: 700, fontSize: 14.5,
          whiteSpace: 'nowrap',
          background: value === id ? '#fff' : 'transparent',
          color: value === id ? 'var(--green-deep)' : 'var(--ink-soft)',
          boxShadow: value === id ? 'var(--shadow-sm)' : 'none',
        }}>{label}</button>
      ))}
    </div>
  );
}

const PERIODS = [['week', 'Vecka'], ['month', 'Månad'], ['year', 'År']];

export function PeriodToggle({ value, onChange, withDay = false }) {
  return <Segmented value={value} onChange={onChange} options={withDay ? [['day', 'Dag'], ...PERIODS] : PERIODS} />;
}
